function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "surface1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M112.875,10.75c-26.66504,0 -48.375,21.70996 -48.375,48.375c0,11.37989 4.11524,21.75196 10.75,30.02442l-53.49804,53.49804l7.55859,7.64258l53.54003,-53.54004c8.27247,6.63477 18.64453,10.75 30.02442,10.75c26.66504,0 48.375,-21.70996 48.375,-48.375c0,-26.66504 -21.70996,-48.375 -48.375,-48.375zM112.875,21.5c20.82813,0 37.625,16.79688 37.625,37.625c0,20.82813 -16.79687,37.625 -37.625,37.625c-20.82812,0 -37.625,-16.79687 -37.625,-37.625c0,-20.82812 16.79688,-37.625 37.625,-37.625z"
}));

var SvgNavigationItemSearch = function SvgNavigationItemSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 172 172",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNavigationItemSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/navigation-item-search.0146855e.svg";
export { ForwardRef as ReactComponent };